
	import { Component, Vue } from 'vue-property-decorator';

	import { VNode } from 'vue';
	import { INotification } from 'ux1-ui-kit';
	import aps from '@/HostApp/store/ApsModules/ApsModule';

	@Component({
		components: {}
	})
	export default class NotificationsNode extends Vue {
		protected created(): void {
			this.wrapMessageBox();
			this.wrapNotifyAndMessage();

			if (aps.navigation.isVueWorkspace) {
				// @ts-ignore
				window.addEventListener('HOST-SHOW-NOTIFICATION', this.showNotificationDetails);
				aps.notifications.api.addEventListener(this.showNotification);
			}
		}

		beforeDestroy(): void {
			// @ts-ignore
			window.removeEventListener('HOST-SHOW-NOTIFICATION', this.showNotificationDetails);
			aps.notifications.api.removeEventListener(this.showNotification);
		}

		// @ts-ignore
		protected showNotificationDetails({ detail }: Array<APS.INotification>): void {
			const [notification] = detail;

			if (notification) {
				const { $createElement: h, $regularMsgBox } = this;

				const message = h('UX1NotificationDetails', {
					props: {
						notification,
						command: 'hz'
					},
					on: {
						action: (event: string): void => {
							this.onActionRequired(event);
						}
					}
				});

				const options = {
					showConfirmButton: false,
					showCancelButton: false,
					lockScroll: true,
					customClass: 'ux1-notification-details-popup'
				};

				$regularMsgBox(message, '', options).catch((err) => {
					//
				});
			}
		}

		protected showNotification(notification: APS.INotification): void {
			if (notification) {
				const { $createElement: h, $notify } = this;

				const command = '/ccp/v/pa/ccp-users/activityLog';
				const customClass = 'ux1-notification-message';

				const message = h('UX1NotificationMessage', {
					props: {
						command,
						notification
					},
					on: {
						action: this.onActionRequired
					}
				});

				$notify({ title: '', message, customClass });
			}
		}

		protected onActionRequired(href: string): void {
			aps.navigation.openLink(href);
		}

		protected wrapMessageBox(): void {
			const messageBoxHandler = {
				apply: <T, I, J, K>(
					target: (arg1: T, arg2: I, options: J) => K,
					thisArg: never,
					argArray?: [T, I, J]
				): VNode => {
					const args = argArray || [];
					const options = args[2] || {};
					//@ts-ignore
					options.appendTo = this.$refs?.notifications as Element;
					// @ts-ignore
					options.customClass = 'ux1-message-box';
					return Reflect.apply(target, thisArg, [args[0], args[1], options]);
				}
			};
			// @ts-ignore
			Vue.prototype.$dangerMsgBox = new Proxy(this.$dangerMsgBox, messageBoxHandler);
			// @ts-ignore
			Vue.prototype.$regularMsgBox = new Proxy(this.$regularMsgBox, messageBoxHandler);
			// @ts-ignore
			Vue.prototype.$regularMsgBoxWithIcon = new Proxy(this.$regularMsgBoxWithIcon, messageBoxHandler);
			// @ts-ignore
			Vue.prototype.$msgbox = new Proxy(this.$msgbox, messageBoxHandler);
			// @ts-ignore
			Vue.prototype.$alert = new Proxy(this.$alert, messageBoxHandler);
			// @ts-ignore
			Vue.prototype.$confirm = new Proxy(this.$confirm, messageBoxHandler);
			// @ts-ignore
			Vue.prototype.$prompt = new Proxy(this.$prompt, messageBoxHandler);
		}

		protected wrapNotifyAndMessage(): void {
			const notificationsHandler = {
				apply: <T, J>(
					target: (data: T, appendTo?: Element) => J,
					thisArg: never,
					argArray?: Array<INotification>
				): VNode => {
					const [options] = argArray || [{} as INotification];
					const appendTo = this.$refs?.notifications as Element;

					return Reflect.apply(target, thisArg, [options, appendTo]);
				}
			};

			this.$message.info = new Proxy(this.$message.info, notificationsHandler);
			this.$message.error = new Proxy(this.$message.error, notificationsHandler);
			this.$message.warning = new Proxy(this.$message.warning, notificationsHandler);
			this.$message.success = new Proxy(this.$message.success, notificationsHandler);

			this.$notify.info = new Proxy(this.$notify.info, notificationsHandler);
			this.$notify.error = new Proxy(this.$notify.error, notificationsHandler);
			this.$notify.warning = new Proxy(this.$notify.warning, notificationsHandler);
			this.$notify.success = new Proxy(this.$notify.success, notificationsHandler);

			Vue.prototype.$notify = new Proxy(this.$notify, notificationsHandler);
			Vue.prototype.$message = new Proxy(this.$message, notificationsHandler);
			Vue.prototype.$notifyPopup = new Proxy(this.$notifyPopup, notificationsHandler);
			Vue.prototype.$notifyPopupWithAction = new Proxy(this.$notifyPopupWithAction, notificationsHandler);
		}
	}
